module.exports = __webpack_public_path__ + "eu_organic_logo-ff249db90687a4f3848459242f2cbe6e.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/eu_organic_logo.png
// module id = 79
// module chunks = 0